var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialIconLinkedinc62239Aacd6E481042F92156A284Bd84(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.536,
    height: 29.536,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16648",
    d: "M14.768 0a14.768 14.768 0 1014.767 14.768A14.768 14.768 0 0014.768 0zm-3.917 21.845H7.912v-9.454h2.939zM9.382 11.099a1.7 1.7 0 111.7-1.7 1.7 1.7 0 01-1.7 1.699zM21.86 21.845h-2.936v-4.6c0-1.1-.021-2.507-1.527-2.507-1.529 0-1.763 1.195-1.763 2.428v4.677h-2.936v-9.454h2.818v1.292h.04a3.087 3.087 0 012.78-1.527c2.974 0 3.524 1.957 3.524 4.5z",
    fill: "#0b75b3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIconLinkedinc62239Aacd6E481042F92156A284Bd84);
export default __webpack_public_path__ + "static/media/social-icon-linkedin.c62239aacd6e481042f92156a284bd84.c62239aacd6e481042f92156a284bd84.svg";
export { ForwardRef as ReactComponent };